<template>
  <q-dialog
    ref="dialog"
    persistent
    content-class="custom-dialog"
    @hide="onDialogHide"
  >
    <q-card class="full-width text-center q-pa-lg border-radius-8">
      <!-- 图标 -->
      <q-card-section class="icon no-padding q-mb-sm">
        <img
          v-if="customIcon"
          style="max-width: 80%; max-height: 100px; margin-top: 4px;"
          :src="customIcon"
        />
        <TypeIcon v-else :type="type" />
      </q-card-section>
      <!-- 标题 -->
      <q-card-section class="title no-padding">
        <div>
          <span style="white-space: pre-line;" v-html="title" />
        </div>
      </q-card-section>
      <!-- 描述 -->
      <q-card-section v-if="describe" class="desc no-padding">
        <div>
          <div v-html="describe" />
        </div>
      </q-card-section>
      <!-- 额外内容 -->
      <q-card-section v-if="extras" class="no-padding">
        <div class="greyColor font-size-12">
          <span>{{ extras }}</span>
        </div>
      </q-card-section>
      <!-- 操作按钮 -->
      <div class="operation q-mt-lg">
        <button class="confirm" @click="onOKClick">{{ ok }}</button>
        <button v-if="cancel" class="cancel" @click="onCancelClick">{{ cancel }}</button>
      </div>
<!--      <q-card-actions vertical class="operation q-mt-lg">-->
<!--        <q-btn-->
<!--          bold-->
<!--          no-caps-->
<!--          unelevated-->
<!--          color="primary"-->
<!--          class="confirm"-->
<!--          :label="ok"-->
<!--          @click="onOKClick"-->
<!--        />-->
<!--        <q-btn-->
<!--          v-if="cancel"-->
<!--          no-caps-->
<!--          :label="cancel"-->
<!--          class="cancel"-->
<!--          @click="onCancelClick"-->
<!--        />-->
<!--      </q-card-actions>-->
    </q-card>
  </q-dialog>
</template>

<script>
import TypeIcon from 'components/dialog/TypeIcon.vue';

export default {
  components: { TypeIcon },
  props: {
    type: {
      type: String,
      default: 'error',
    },
    customIcon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'System Error',
    },
    describe: {
      type: String,
      default: '',
    },
    extras: {
      type: Object,
      default: () => {},
    },
    ok: {
      type: String,
      default: '',
    },
    cancel: {
      type: String,
      default: '',
    },
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    },
    onOKClick() {
      this.$emit('ok');
      this.hide();
    },
    onCancelClick() {
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #374151;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.desc {
  margin-top: 8px;
  color: #374151;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.operation {
  display: flex;
  gap: 12px;
  button {
    flex: 1;
    display: flex;
    height: 50px;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
  .confirm {
    background:  #C63527;
  }
  .cancel {
    background: #10B981;
  }
}
</style>
